<template>

  <div>
    <Modal
      title="Remove Product from Location"
      :submit="submit"
      submit-label="Delete"
      :submitting="submitting"
    >

      <p>Are you sure you want to remove this product?</p>

      <p>This cannot be undone!</p>

    </Modal>
  </div>    

</template>

<script setup lang="ts">

import { ref } from 'vue'
// TODO: i18n
import Modal from '../../../Modal.vue'
// @ts-ignore
import { closeDialog } from 'vue3-promise-dialog'
import LocationProduct from '../../../../models/LocationProduct'
import NotificationService from '../../../../services/NotificationService'

interface Props {
  locationProduct: LocationProduct
}

const props = defineProps<Props>()

const submitting = ref<boolean>(false)

async function submit() {

  if (!props.locationProduct.locationID) {
    throw new Error('can\'t delete a LocationProduct that has no ID')
  }

  submitting.value = true

  LocationProduct.destroy(props.locationProduct.locationID, props.locationProduct.ID)
    .then(() => {
      NotificationService.success('Product removed from location')
      closeDialog(null)
    })
    .catch((error) => {
      console.error(error)
      NotificationService.error('Couldn\'t remove product from location!')
    })
    .finally(() => {
      submitting.value = true
    })

}

</script>
